
// SVG Icon: folder-open
export default { id: "terriajs-folder-open" };
export const id = "terriajs-folder-open";
export const name = "folder-open";
